import React from 'react';
import { connect } from 'react-redux';

import { number, string, func } from 'prop-types';
import MenuItem from 'material-ui/MenuItem';
import DropDown from './DropDownTitled';

import { getSelectedCrimeTypes } from '../selectors/options';

export const CrimeTypeSelector = ({
  labelColor,
  onChange,
  value,
  children,
  inDataSettings = false,
  crimeTypes,
  isCensus,
}) => {
  return (
    <DropDown
      value={value}
      title="Crime Type:"
      labelStyle={{ color: labelColor }}
      style={{ width: '214px' }}
      onChange={(e, i, val) => onChange(val)}
      iconStyle={{
        fill: inDataSettings
          ? 'rgba(0, 0, 0, .87)'
          : 'rgba(255, 255, 255, 0.93)',
      }}
    >
      {crimeTypes.map(({ id, name }, i) => {
        return <MenuItem key={i} value={id} primaryText={name} title={name} />;
      })}
      {children}
    </DropDown>
  );
};
CrimeTypeSelector.propTypes = {
  value: number.isRequired,
  onChange: func.isRequired,
  crime: string,
};

export default connect(state => ({
  crimeTypes: getSelectedCrimeTypes(state),
}))(CrimeTypeSelector);



// WEBPACK FOOTER //
// ./src/components/CrimeTypeSelector.jsx